import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

export const SectionHeader = ( props ) => {

    return (
        <div className={ classNames( 'section-header', props.className ) }>
            <h2>{ props.children }</h2>
        </div>
    );
};

SectionHeader.propTypes = {
    className: PropTypes.string
};
